<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<h3 class="ui primary header">Non-Network Operator’s Assessment</h3>
<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
</div>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="detailForm">
      <div
        class="field required"
        [ngClass]="displayFieldCss('nonNetworkOperatorLicenseType')"
      >
        <label>License Type</label>
        <sui-select
          class="selection"
          [options]="lookupTemplates"
          [isSearchable]="true"
          labelField="optionName"
          valueField="optionId"
          formControlName="nonNetworkOperatorLicenseType"
          #select
        >
          <sui-select-option
            *ngFor="let option of select.filteredOptions"
            [value]="option"
          >
          </sui-select-option>
        </sui-select>
        <app-field-error-display
          [displayError]="isFieldValid('nonNetworkOperatorLicenseType')"
          errorMsg="Please select License Type"
        >
        </app-field-error-display>
      </div>
      <div class="field required" [ngClass]="displayFieldCss('licenseNumber')">
        <label>License Number</label>
        <input
          formControlName="licenseNumber"
          type="text"
          placeholder="License Number"
        />
        <app-field-error-display
          [displayError]="isFieldValid('licenseNumber')"
          errorMsg="Please enter License Number"
        >
        </app-field-error-display>
      </div>

      <div class="field required" [ngClass]="displayFieldCss('grossRevenue')">
        <label>Gross Revenue</label>
        <input
          formControlName="grossRevenue"
          type="number"
          placeholder="Gross Revenue"
        />
        <app-field-error-display
          [displayError]="isFieldValid('grossRevenue')"
          errorMsg="Please enter Gross Revenue"
        >
        </app-field-error-display>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Close
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!detailForm.valid ||pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
